import { render, staticRenderFns } from "./gardenModel.vue?vue&type=template&id=6a4c5222&scoped=true&"
import script from "./gardenModel.vue?vue&type=script&lang=js&"
export * from "./gardenModel.vue?vue&type=script&lang=js&"
import style0 from "./gardenModel.vue?vue&type=style&index=0&id=6a4c5222&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4c5222",
  null
  
)

export default component.exports